import { shallowRef } from '@vue/reactivity'
import { stopTracks } from '@browser'
import { EventBus } from 'communication/src/EventBus'
export default class LocalAudioStream extends EventBus {
  constructor() {
    super()
    this.updatedAt = shallowRef(Date.now())
    this.stream = shallowRef(new window.MediaStream)
    this.source = null
  }

  addTrack(track, source = 'browser') {
    this.source = source
    this.stream.value.addTrack(track)
    this.updatedAt.value = Date.now()
    this.emit('addTrack', track)
  }

  getTrack() {
    return this.stream.value.getAudioTracks()[0]
  }

  removeTrack(track) {
    this.stream.value.removeTrack(track)
  }

  update() {
    this.updatedAt = Date.now()
  }

  replaceTrack(oldTrack, newTrack) {
    this.stream.value.removeTrack(oldTrack)
    this.stream.value.addTrack(newTrack)
    this.updatedAt.value = Date.now()
    this.emit('replaceTrack', { oldTrack, newTrack })
  }

  stop = () => {
    if (this.stream.value) stopTracks(this.stream.value)
    this.stream.value = new window.MediaStream()
  }
}
